import { PhoneSupportCallCaseAddRequest } from "interfaces/Mueller.Business.Models";
import { HTTP_GET, HTTP_POST, WebApiRequest } from "tools/webservice";

export const addPhoneSupportCallCase = (payload: PhoneSupportCallCaseAddRequest, successCallback:() => void, mountedRef: { current: boolean }) => WebApiRequest({
  method: HTTP_POST,
  endpoint: "/phone-support-calls/phone-support-call-cases",
  payload,
  successCallback,
  mountedRef,
});
